<template>
  <div name="comp-graph" class="comp-graph">
    <div class="column">
      <h1 class="title">{{ graphTitle }}</h1>

      <div class="graph" v-if="getGraphType === 'coordinate'">
        <table class="type-9-blocks">
          <colgroup>
            <col width="19%" />
            <col width="27%" />
            <col width="27%" />
            <col width="27%" />
          </colgroup>
          <tr>
            <th>Exploring Ideas</th>
            <td colspan="3" rowspan="3">
              <table class="grid">
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>

              <div class="value-container">
                <div
                  class="value"
                  v-for="(coordinate, idx) in getCoordinateLoc"
                  :key="idx"
                  :style="{ top: coordinate.y, left: coordinate.x }"
                ></div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Finding Solutions</th>
          </tr>
          <tr>
            <th>Evaluating Evidence</th>
          </tr>
          <tr>
            <th></th>
            <th>Big Picture Oriented</th>
            <th>Circumstance Oriented</th>
            <th>Detail Oriented</th>
          </tr>
        </table>
      </div>

      <div class="graph" v-else-if="getGraphType === 'line'">
        <table class="type-horizontal">
          <colgroup>
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
          </colgroup>
          <tr>
            <!-- 0em ~ 10em 까지 / 0일 경우 그래프 최대, 10일 경우 그래프 최소값 -->
            <td v-for="(column, idx) in getGraphValue" :key="idx">
              <span :style="{ height: getLineGraphValue(column) }"></span>
            </td>
          </tr>
          <tr>
            <th v-for="(column, idx) in getGraphValue" :key="idx">
              {{ getColumnFromGraphData(column) }}
            </th>
          </tr>
        </table>
      </div>

      <div class="graph" v-else-if="getGraphType === 'line2'">
        <table class="type-horizontal has-guide">
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>
          <tr>
            <!-- 0em ~ 10em 까지 / 0일 경우 그래프 최대, 10일 경우 그래프 최소값 -->
            <td v-for="(column, idx) in getGraphValue" :key="idx">
              <span :style="{ height: getLineGraphValue(column) }"></span>
            </td>
          </tr>
          <tr>
            <th v-for="(column, idx) in getGraphValue" :key="idx">
              {{ getColumnFromGraphData(column) }}
            </th>
          </tr>
        </table>
      </div>

      <div class="graph" v-else-if="getGraphType === 'bar'">
        <table class="type-vertical">
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>
          <tr>
            <th colspan="2">{{ graphData.subTitle1 }}</th>
          </tr>
          <tr v-for="(row, idx) in getGraphValue" :key="idx">
            <td v-if="idx === 1"></td>
            <!-- 0em ~ 10em 까지 / 0일 경우 그래프 최대, 10일 경우 그래프 최소값 -->
            <td class="has-bar">
              <span :style="{ width: getBarGraphValue(row) }"></span>
            </td>
            <td v-if="idx === 0"></td>
          </tr>
          <tr>
            <th colspan="2">{{ graphData.subTitle2 }}</th>
          </tr>
        </table>
      </div>

      <div class="graph" v-else-if="getGraphType === 'etc'">
        <table class="type-list">
          <colgroup>
            <col width="30%" />
            <col width="70%" />
          </colgroup>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
          <tr>
            <th>title</th>
            <td><span style="width: 10%"></span></td>
          </tr>
        </table>
      </div>
      <div class="desc">{{ graphDesc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompGraph',
  props: {
    graphData: Object
  },
  data() {
    return {
      graphTitle: '',
      graphDesc: ''
    }
  },
  created() {
    this.updateContent()
  },
  updated() {
    this.updateContent()
  },
  computed: {
    getGraphType() {
      return this.graphData.graphType
    },
    getGraphValue() {
      const keys = Object.keys(this.graphData)

      const graphValues = []
      keys.forEach(key => {
        if (Number.isFinite(this.graphData[key])) {
          const json = {}
          json[key] = this.graphData[key]
          graphValues.push(json)
        }
      })
      return graphValues
    },
    getCoordinateLoc() {
      const coLocList = []
      this.graphData.coordinate.forEach(coordinate => {
        var locJSON = {}
        locJSON = {
          x: parseInt(coordinate.x) * 10 + '%',
          y: 100 - parseInt(coordinate.y) * 10 + '%'
        }

        coLocList.push(locJSON)
      })
      return coLocList
    }
  },
  methods: {
    titleCase(str) {
      const camelToSpace = str.replace(
        /[A-Z]/g,
        letter => ` ${letter.toLowerCase()}`
      )
      var splitStr = camelToSpace.toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
      }
      // Directly return the joined string
      return splitStr.join(' ')
    },
    updateContent() {
      this.graphTitle = this.graphData.title
      this.graphDesc = this.graphData.description
    },
    getLineGraphValue(column) {
      const value = this.graphData[Object.keys(column)[0]]
      return 10 - value + 'em'
    },
    getColumnFromGraphData(graphValue) {
      return this.titleCase(Object.keys(graphValue)[0])
    },
    getBarGraphValue(row) {
      const value = this.graphData[Object.keys(row)[0]]
      return 10 - Math.abs(value * 10) + 'em'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/rooms.scss" scoped></style>
